// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import * as React from 'react'
import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full rounded-xl border border-border bg-card dark:bg-input-bg px-4 text-sm',
        'text-foreground placeholder:text-muted-foreground',
        'focus:outline-none focus:ring-2 focus:ring-ring',
        className
      )}
      {...props}
    />
  )
)
Input.displayName = 'Input'

export { Input }
